export default function initPolicyNavigation() {
    const textContainer = document.getElementById('js-policy-text');
    const navList = document.getElementById('js-policy-nav-list');

    // Trazendo a sidebar de volta para controlarmos o scroll dela
    const sidebar = document.querySelector('.c-policy-content__sidebar');

    if (!textContainer || !navList || !sidebar) return;

    const headings = textContainer.querySelectorAll('h2');

    if (headings.length === 0) return;

    const slugify = (text) => {
        return text.toString().toLowerCase().trim()
            .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
            .replace(/\s+/g, '-').replace(/[^\w\-]+/g, '')
            .replace(/\-\-+/g, '-');
    };

    headings.forEach((heading, index) => {
        const rawText = heading.textContent || `Secao ${index + 1}`;
        const headingId = slugify(rawText);

        heading.id = headingId;

        const listItem = document.createElement('li');
        listItem.classList.add('c-policy-nav__item');

        const link = document.createElement('a');
        link.href = `#${headingId}`;
        link.textContent = rawText;
        link.classList.add('c-policy-nav__link');

        link.addEventListener('click', (e) => {
            e.preventDefault();
            heading.scrollIntoView({ behavior: 'smooth', block: 'start' });
            history.pushState(null, null, `#${headingId}`);
        });

        listItem.appendChild(link);
        navList.appendChild(listItem);
    });

    const links = navList.querySelectorAll('.c-policy-nav__link');

    const observerOptions = {
        root: null,
        rootMargin: '-20% 0px -60% 0px',
        threshold: 0
    };

    const observerCallback = (entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                const id = entry.target.getAttribute('id');

                links.forEach(link => {
                    link.classList.remove('is-active');
                    if (link.getAttribute('href') === `#${id}`) {
                        link.classList.add('is-active');

                        // Correção do scroll: apenas a sidebar rola internamente
                        if (window.innerWidth >= 768) {
                            // Calcula a posição para deixar o link no meio da sidebar
                            const scrollPos = link.offsetTop - (sidebar.clientHeight / 2) + (link.clientHeight / 2);

                            sidebar.scrollTo({
                                top: scrollPos,
                                behavior: 'smooth'
                            });
                        }
                    }
                });
            }
        });
    };

    const observer = new IntersectionObserver(observerCallback, observerOptions);

    headings.forEach(heading => observer.observe(heading));
}